<template class="height100">
  <div class="page-container" v-bind:class="[extraClass]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['extraClass']
}
</script>
